(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-header"]) return;
  try {
    
// toggle read more on collection
let isReadMore = document.getElementsByClassName('js--read-more');
if (isReadMore.length > 0) {
  document.querySelector('.js--read-more').addEventListener('click', function(){
    document.querySelector('.collection__description').classList.toggle('expanded');
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-hero"] && !window.DesignMode) return;
  try {
    
// toggle read more on collection
let isReadMore = document.getElementsByClassName('js--read-more');
if (isReadMore.length > 0) {
  document.querySelector('.js--read-more').addEventListener('click', function(){
    document.querySelector('.collection__description').classList.toggle('expanded');
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
    function stickySubNav() {
      let lastScroll = 0;
      //window.on('resize', theme.utils.debounce(50, ));
      window.on('scroll', theme.utils.throttle(20, subNavScroll));
  
    }
    function subNavScroll(){
      const subNav = document.querySelector('.collection-nav');
      const subNavList = document.querySelector('.collection-nav--list')
      if(subNav.offsetTop <= (window.scrollY + 76)){
        subNavList.classList.add('collection-nav--sticky')
      }else{
        subNavList.classList.remove('collection-nav--sticky')
      }
    }

    stickySubNav();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
    function stickySubNav() {
      let lastScroll = 0;
      //window.on('resize', theme.utils.debounce(50, ));
      window.on('scroll', theme.utils.throttle(20, subNavScroll));
  
    }
    function subNavScroll(){
      const subNav = document.querySelector('.collection-nav');
      const subNavList = document.querySelector('.collection-nav--list')

      console.log(subNav.offsetTop);
      if(subNav.offsetTop <= (window.scrollY + 76)){
        subNavList.classList.add('collection-nav--sticky')
      }else{
        subNavList.classList.remove('collection-nav--sticky')
      }
    }

    stickySubNav();
  });

  } catch(e) { console.error(e); }
})();
})();
